import { InjectionToken } from '@angular/core';

import { MediaModuleConfiguration } from '.';

export const MediaConfigurationService = new InjectionToken<MediaModuleConfiguration>('MediaModuleConfiguration');
